<script lang="ts">
  import { SimpleHeader } from '@athena-lib/Header/SimpleHeader';
  import type { ExpandedHeader } from '$lib/server/expanders/header';

  const {
    blok,
  }: {
    blok: ExpandedHeader;
  } = $props();

  const headerProps = $derived({
    stickerAppLogoUrl: blok.logo.filename ?? '',
    backUrl: blok.checkoutBackUrl ?? '/',
  });
</script>

<SimpleHeader {...headerProps} />
